
import MultiPreset from "../components-presets/multi-doc-presets/MultiPreset";
import PreviewChoose from "../PreviewChoose";

export default function MultiDoc({attributes, setAttributes, docPosts, multiDocs}){
    const {
        docPreset,
        articlesNumber,
        show_docs
    } = attributes;

    // sections title post
    const docSections = []

    // let docPostsTitle = [ { label: 'Select a Doc title', value:null } ];
    let docPostsTitle = [];

    if (docPosts && docPosts.length > 0) {
        docPostsTitle = docPosts.map(post => ({
            label: post.title.rendered,
            value: post.id,
        }));
    }

    let presetTemplate;
    
    presetTemplate = <MultiPreset docSections={ docSections } attributes={attributes} articlesNumber={articlesNumber} multiDocs={multiDocs} show_docs={show_docs} />;
    
    return (
        <>
            <PreviewChoose attributes={ attributes } setAttributes={ setAttributes }  />
            { presetTemplate }
        </>
    );
}